import type { TaskAggregateGroupBy } from "@gw/shared-types";

export interface GroupByOption {
  key: TaskAggregateGroupBy;
  label: string;
}

const GROUP_BY_OPTIONS: GroupByOption[] = [
  { key: "taskName", label: "Task name" },
  { key: "taskCategory", label: "Category" },
  { key: "taskType", label: "Task type" },
  { key: "client", label: "Client" },
  { key: "lineOfBusiness", label: "LOB" },
  { key: "engagementType", label: "Eng. type" },
  { key: "assignedTo", label: "Assigned to" },
  { key: "templateName", label: "Template" },
];

export interface GroupByPreset {
  label: string;
  keys: TaskAggregateGroupBy[];
}

const PRESETS: GroupByPreset[] = [
  { label: "Task × Client", keys: ["taskName", "client"] },
  { label: "Task × LOB", keys: ["taskName", "lineOfBusiness"] },
  { label: "Task × Engagement", keys: ["taskName", "engagementType"] },
  { label: "Category × Client", keys: ["taskCategory", "client"] },
];

interface Props {
  selected: TaskAggregateGroupBy[];
  onChange: (next: TaskAggregateGroupBy[]) => void;
}

export function GroupByChips({ selected, onChange }: Props) {
  const toggle = (key: TaskAggregateGroupBy) => {
    if (selected.includes(key)) {
      // Keep at least one group key active — the aggregate view degenerates without one.
      if (selected.length > 1) onChange(selected.filter((k) => k !== key));
      return;
    }
    onChange([...selected, key]);
  };

  return (
    <div className="groupby">
      <span className="lbl">Group by</span>
      {GROUP_BY_OPTIONS.map((opt) => {
        const active = selected.includes(opt.key);
        return (
          <span
            key={opt.key}
            className={"groupby-chip " + (active ? "active" : "")}
            onClick={() => toggle(opt.key)}
          >
            {opt.label}
            {active && (
              <span className="material-symbols-rounded" style={{ fontSize: 12 }}>
                close
              </span>
            )}
          </span>
        );
      })}
      <div className="groupby-presets">
        {PRESETS.map((p) => (
          <span key={p.label} className="preset" onClick={() => onChange(p.keys)}>
            {p.label}
          </span>
        ))}
      </div>
    </div>
  );
}

export const GROUP_LABEL_BY_KEY: Record<TaskAggregateGroupBy, string> = Object.fromEntries(
  GROUP_BY_OPTIONS.map((o) => [o.key, o.label]),
) as Record<TaskAggregateGroupBy, string>;
